"use client";
import { myPhotoPath } from "@/lib/lib";
import { cn } from "@/lib/utils";
import { PulsingBorder } from "@paper-design/shaders-react";
import { motion } from "framer-motion";
import Image from "next/image";

interface PhotoWithPulsingBorderShaderProps {
  className?: string;
  showPreview?: boolean;
}

export default function PhotoWithPulsingBorderShader({
  className,
  showPreview = false,
  ...props
}: PhotoWithPulsingBorderShaderProps) {
  return (
    <div
      className={cn(
        "transition-all duration-700 ease-in-out hover:scale-110 relative h-44 w-44 md:h-[200px] md:w-[200px] lg:h-[250px] lg:w-[250px]",
        className
      )}
    >
      <PulsingBorder
        colors={["#5800FF", "#BEECFF", "#E77EDC", "#FF4C3E"]}
        colorBack="#00000000"
        speed={1.5}
        roundness={1}
        thickness={0.05}
        softness={0.1}
        intensity={1}
        spots={5}
        spotSize={0.1}
        pulse={0.2}
        smoke={0.5}
        smokeSize={2}
        scale={0.8}
        rotation={0}
        frame={9161408.251009725}
        style={{
          position: "absolute",
          // width: "535px",
          // height: "511px",
          // borderRadius: "9999px",
          width: "100%",
          height: "100%",
          zIndex: 50,
          borderRadius: "0px",
          backgroundImage:
            "radial-gradient(circle in oklab, oklab(0% 0 -.0001 / 0%) 25.22%, oklab(30.5% 0.029 -0.184) 43.89%, oklab(0% 0 -.0001 / 0%) 60.04%)",
        }}
        {...props}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
          transition: {
            delay: 0.3,
            ease: "easeIn",
            duration: 0.8,
          },
        }}
      >
        <Image
          src={myPhotoPath}
          quality={100}
          // priority
          // unoptimized
          className="rounded-full overflow-hidden object-fill p-8"
          fill
          alt="Hamza Photo"
          // sizes="(max-width: 640px) 200px, (max-width: 768px) 250px, (max-width: 1024px) 300px, (max-width: 1280px) 400px, 450px"
        />
      </motion.div>
    </div>
  );
}
